var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("lib-pricing", {
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function (props) {
          return [
            _c("actions-widget", {
              attrs: { "can-purchase": props.canPurchase },
              on: {
                "free-trial": function ($event) {
                  return _vm.submitCart(props.cart, "trial")
                },
                purchase: function ($event) {
                  return _vm.submitCart(props.cart, "full")
                },
              },
            }),
          ]
        },
      },
    ]),
    model: {
      value: _vm.selection,
      callback: function ($$v) {
        _vm.selection = $$v
      },
      expression: "selection",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }